module.exports = __webpack_public_path__ + "static/media/Book - It Makes Sense to Believe 2.26d1f623.pdf";